export default __webpack_public_path__ + "static/media/00-ground.554d6953.png";